import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App";
import appPackage from "../package.json";
import "./styles.css";

const deployment = {
  version: appPackage.version,
  commit: import.meta.env.VITE_ENSEMBLE_COMMIT ?? "local",
  builtAt: import.meta.env.VITE_ENSEMBLE_BUILT_AT,
};

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App deployment={deployment} />
  </StrictMode>,
);

if ("serviceWorker" in navigator && !import.meta.env.DEV) {
  window.addEventListener("load", () => {
    void navigator.serviceWorker
      .register("/service-worker.js", { updateViaCache: "none" })
      .then((registration) => registration.update());
  });
}
